const SaleStatus = ({
  isOn,
  isEnd,
  quantity,
  currentPurchasedCount,
}: {
  isOn: boolean;
  isEnd?: boolean;
  quantity: number;
  currentPurchasedCount: number;
}) => {
  return (
    <div className="flex flex-col items-start gap-2">
      {isEnd ? (
        <span className="flex items-center">
          <div className="w-3 h-3 rounded-full bg-red-500 mr-1" />이 팩은
          판매종료되었어요
        </span>
      ) : (
        <></>
      )}
      {isOn && !isEnd ? (
        <>
          <span className="flex items-center">
            <div className="w-3 h-3 rounded-full bg-green-500 mr-1" />
            현재 이 팩을{" "}
            <strong className="mx-2 mb-1">
              <span className="text-3xl">{quantity}</span>개 판매중
            </strong>
          </span>
          <span className="flex items-center">
            <div
              className={`w-3 h-3 rounded-full  ${
                currentPurchasedCount >= 1
                  ? "bg-blue-500 animate-bounce"
                  : "bg-gray-500"
              } mr-1`}
            />
            현재 이 팩은
            <strong className="mx-2 mb-1">
              <span className="text-3xl">{currentPurchasedCount}</span>개 구매됨
            </strong>
          </span>
          {quantity === currentPurchasedCount && (
            <span className="text-green-700 px-2 py-1 rounded-md bg-green-100 font-bold">
              완판!
            </span>
          )}
        </>
      ) : (
        <>
          <span className="flex items-center">
            <div
              className={`w-3 h-3 rounded-full  ${
                currentPurchasedCount >= 1
                  ? "bg-blue-500 animate-bounce"
                  : "bg-gray-500"
              } mr-1`}
            />
            이 팩은
            <strong className="mx-2 mb-1">
              <span className="text-3xl">{currentPurchasedCount}</span>개 구매됨
            </strong>
          </span>
        </>
      )}
    </div>
  );
};

export default SaleStatus;
